<template>
    <section v-if="author" class="author">
        <div>
            <img alt="author-image" v-lazy="profileImage" />
        </div>
        <div class="container">
            <div class="content">
                <p>
                    <a :href="author['url']" class="name">
                        {{ author['first_name'] + ' ' + author['last_name'] }}
                    </a>
                </p>
                <p class="date">{{ $t('Updated On') }} {{ lastUpdateDate }}</p>
                <p class="fact-check" v-if="showFactCheck">
                    <span> ★ {{ $t('Fact-checked-by') }}</span>
                </p>
            </div>
            <div>
                <p class="job-title">{{ $t(author['job_title']) }}</p>
            </div>
        </div>
    </section>
</template>

<script>
import { DateMixin } from '@/ghost-mixins';
export default {
    name: 'AuthorCard',
    mixins: [DateMixin],
    props: {
        author: Object,
    },
    data() {
        return {
            profileImage: this.getProfileImage(),
            showFactCheck: false,
            lastUpdateDate: this.getBrowserData() ?? this.fallbackDate(),
        };
    },
    methods: {
        getProfileImage() {
            return `${this.author['image']}?d=${100}x${100}&q=${90}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.author {
    display: flex;
    gap: 15px;
    align-content: center;
    align-items: center;
    margin: 10px 0 20px;

    div {
        img {
            width: 50px;
            height: 50px;
            object-fit: cover;
            border-radius: 50px;
        }
    }

    .container {
        display: flex;
        gap: 5px;
        flex-direction: column;

        .content {
            display: flex;
            gap: 5px;
            align-items: normal;
            font-size: 15px;
            flex-direction: column;

            @include mq('tablet') {
                flex-direction: row;
                align-items: center;
                gap: 10px;
            }

            .name {
                font-size: 17px;
                color: #1d69a7;
                font-weight: 600;
            }
            .date {
                color: rgba(85, 78, 78, 0.87);
                border: none;
                padding-inline-start: 0;
                margin-inline-start: 0;

                @include mq('tablet') {
                    margin-inline-start: 3px;
                    border-inline-start: 1px solid #787676;
                    padding-inline-start: 8px;
                }
            }
            .fact-check {
                border: none;
                padding-inline-start: 0;
                margin-inline-start: 0;

                @include mq('tablet') {
                    margin-inline-start: 3px;
                    border-inline-start: 1px solid #787676;
                    padding-inline-start: 8px;
                }

                span {
                    border: solid 1px #1f841f;
                    padding: 5px;
                    color: #1f841f;
                    border-radius: 4px;
                }
            }
        }

        .job-title {
            font-size: 15px;
            color: rgba(85, 78, 78, 0.87);
        }
    }
}
</style>
